import { render, staticRenderFns } from "./add_money.vue?vue&type=template&id=0572f2cb&"
import script from "./add_money.vue?vue&type=script&lang=js&"
export * from "./add_money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports